<template>
  <div>
    <filter-data
      :extra-filters-count="1"
      with_text_search
      :with_client="false"
      :with_date_start="false"
      :with_date_end="false"
      @doneFilter="handleDoneFilter"
    >
      <template v-slot:extra-filters>
        <v-col cols="12" md="6">
          <v-select
            v-model="envelope_filter"
            multiple
            outlined
            dense
            hide-details="auto"
            :items="envelope_type"
            item-text="text"
            item-value="value"
            prepend-inner-icon="mdi-email"
            label="Envelopes"
          />
        </v-col>
      </template>
    </filter-data>
    <envelope-table :items="allEnvelopes" :loading='loading' :table-search="tableSearch"
      @doneNewEnvelope='handleDoneNewEnvelope' @done="getEnvelopes"
      @doneConfirm="handleDoneConfirm"
      @doneDelete="handleDoneDelete" 
    ></envelope-table>
  </div>
</template>

<script>
const CONFIRMED = 1
const CONCLUDED = 2
const PAYED_ID = 7

import { mapActions, mapState, mapGetters } from 'vuex'
import status from "@/_backoffice/_financial/mixins/status.js"

export default {
  name: 'OpenEnvelopes',
  mixins: [status],
  inject: {
    registerEnvelopesListReload: {
      default: () => () => {},
    },
  },
  components: {
    EnvelopeTable: () => import('./shared/EnvelopeTable'),
    FilterData: () => import('@/components/shared/FilterData.vue'),
  },
  data() {
    return {
      loading: false,
      local_filter: {},
      comment: '',
      comment_dialog: false,
      envelope_filter: [CONFIRMED],
      envelope_type:[
        // { text:"ABERTOS", value: PAYED_ID },
        { text:"CONFIRMADOS", value: CONFIRMED },
        { text:"CONCLUÍDOS", value: CONCLUDED},
      ],
    }
  },

  computed: {
    tableSearch() {
      return (this.local_filter && this.local_filter.query) ? String(this.local_filter.query) : ''
    },
    ...mapState({
      allEnvelopes: state => state.Envelope.allEnvelopes,
    }),
  },

  methods: {
    handleDoneFilter(e){
      this.local_filter = { ...e }
      this.getEnvelopes()
    },
    handleDoneNewEnvelope(e){
      this.getEnvelopes()
    },
    handleDoneConfirm(e){
      this.getEnvelopes()
    },
    handleDoneDelete(e){
      this.getEnvelopes()
    },
    seeComment(comment) {
      this.comment = comment
      this.comment_dialog = true
    },
    getFilter(){
      let filter = {
        modality_ids: [this.activeModalityId],
        ...this.local_filter,
      }
      if(this.envelope_filter.includes(PAYED_ID)){
        filter.status_ids = [PAYED_ID]
      }
      if(this.envelope_filter.includes(CONFIRMED)){
        filter.is_confirmed = true
        filter.status_ids = [PAYED_ID]
      }
      if(this.envelope_filter.includes(CONCLUDED)){
        filter.is_concluded = true
      }
      return filter
    },
    getEnvelopes(){
      if (this.activeModalityId){
        this.loading = true
        let filters = this.getFilter()
        this.indexEnvelopes(filters).finally(()=>{
          this.loading = false
        })
      }
    },
    ...mapActions({
      indexEnvelopes: 'Envelope/index',
    })
  },
  mounted() {
    this.registerEnvelopesListReload(this.getEnvelopes)
  },
  beforeDestroy() {
    this.registerEnvelopesListReload(null)
  },
}
</script>
